import { Button, useMantineTheme } from '@mantine/core'
import { hoverCssKey } from 'components/Button/_utils/getButtonComponent'
import { forwardRef } from 'react'
import type { MantineButtonProps } from '../../Button'

const Link = forwardRef<HTMLButtonElement, MantineButtonProps>(({ size, ...props }, ref) => {
  const theme = useMantineTheme()

  return (
    <Button
      ref={ref}
      size={`compact-${size ?? 'sm'}`}
      css={{
        'backgroundColor': 'transparent',
        'border': 'none',
        'color': theme.colors.primary[0],
        'textDecoration': 'underline',
        // Mantine's Button repaints its text and background on hover and :active, so restate ours
        '&:hover, &:active': { backgroundColor: 'transparent', color: theme.colors.primary[0] },
        [`&:not([disabled],[data-loading="true"]):${hoverCssKey}`]: {
          textDecoration: 'none',
          backgroundColor: 'transparent',
        },
        '&[disabled],&[data-loading="true"],&[data-loading="true"]::before': {
          'color': theme.colors.grey[2],
          '&:hover': { textDecoration: 'underline' },
          'backgroundColor': 'transparent',
        },
        '&[disabled],&[data-loading="true"]': {
          svg: {
            fill: theme.colors.grey[3],
          },
        },
      }}
      {...props}
    />
  )
})

Link.displayName = 'Link'

export { Link }
